export const QUERY_KEYS = {
  METAFIELDS: "getCustomerMetafields",
} as const
